import NumberInputField from './NumberInputField'
import ImageUploadField from './ImageUploadField'
import RadioGroupField from './RadioField'
import CheckBoxMultiGroupField from './CheckBoxMultiGroup'
import AddingListField from './AddingListField'
import DatePickerField from './DatePickerField'
import { TextInputIconPosition } from '../Inputs/TextInput'
import { Country } from 'services/api/constants'
import { FormikTextArea } from 'particles/TextInputs/TextArea'
import { FormikTextField } from 'particles/TextInputs/TextField'

export interface BaseFieldProps {
    name?: string
    width?: string
    height?: string
    placeholder?: string
    title?: string
    subtitle?: string
    isRequired?: boolean
    isDisable?: boolean
    isReadOnly?: boolean
    identifier?: string
}
export interface TextInputFieldProps extends BaseFieldProps {
    showInputLength?: boolean
    maxInputLength?: number
    isError?: boolean
    iconPosition?: TextInputIconPosition
    IconComponent?: React.ReactElement
}
export interface DatePickerFieldProps extends BaseFieldProps {
    readOnlyForPastDate?: boolean
    country: Country
    identifier?: string
}

const InputField = {
    NumberInputField: NumberInputField,
    TextInputField: FormikTextField,
    ImageUploadField: ImageUploadField,
    RadioGroupField: RadioGroupField,
    CheckBoxMultiGroupField: CheckBoxMultiGroupField,
    AddingListField: AddingListField,
    DatePickerField: DatePickerField,
    TextAreaField: FormikTextArea,
}

export default InputField
